export const DataStorage = sessionStorage;
export const KEY_ACCESS_TOKEN = 'access_token';
export const VERSION = '1.0.2'
